// ** React Imports
import { Fragment, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

// ** Third Party Components
import classnames from "classnames"

// ** Reactstrap Imports
import { Collapse, Badge } from "reactstrap"

// ** Vertical Menu Items Component
import VerticalNavMenuItems from "./VerticalNavMenuItems"

// ** Utils
import { hasActiveChild, removeChildren } from "@layouts/utils"


const VerticalNavMenuGroup = ({
    item,
    groupOpen,
    menuHover,
    activeItem,
    parentItem,
    groupActive,
    setGroupOpen,
    menuCollapsed,
    setGroupActive,
    currentActiveGroup,
    setCurrentActiveGroup,
    ...rest
}) => {

    // ** Hooks

    const location = useLocation()
    const navigate = useNavigate()

    // ** Current Val
    const currentURL = useLocation().pathname

    // ** Toggle Open Group
    const toggleOpenGroup = (item, parent) => {

        let openGroup = groupOpen
        const activeGroup = groupActive

        // ** If Group is already open and clicked, close the group
        if (openGroup.includes(item.id)) {
            openGroup.splice(openGroup.indexOf(item.id), 1)

            // ** If clicked Group has open group children, Also remove those children to close those groups
            if (item.children) {
                removeChildren(item.children, openGroup, groupActive)
            }
        } else if (
            activeGroup.includes(item.id) ||
            currentActiveGroup.includes(item.id)
        ) {
            // ** If Group clicked is Active Group

            // ** If Active group is closed and clicked again, we should open active group else close active group
            if (
                !activeGroup.includes(item.id) &&
                currentActiveGroup.includes(item.id)
            ) {
                activeGroup.push(item.id)
            } else {
                activeGroup.splice(activeGroup.indexOf(item.id), 1)
            }

            // ** Update Active Group
            setGroupActive([...activeGroup])
        } else if (parent) {
            // ** If Group clicked is the child of a open group, first remove all the open groups under that parent
            if (parent.children) {
                removeChildren(parent.children, openGroup, groupActive)
            }

            // ** After removing all the open groups under that parent, add the clicked group to open group array
            if (!openGroup.includes(item.id)) {
                openGroup.push(item.id)
            }
        } else {
            // ** If clicked on another group that is not active or open, create openGroup array from scratch

            // ** Empty Open Group array
            openGroup = []

            // ** Push current clicked group item to Open Group array
            if (!openGroup.includes(item.id)) {
                openGroup.push(item.id)
            }
        }
        setGroupOpen([...openGroup])
    }

    const onCollapseClick = (e, item) => {

        e.preventDefault() // Prevent default navigation behavior

        // Open the menu if not already open
        if (!groupOpen.includes(item.id)) {
            toggleOpenGroup(item, parentItem)
        }

        // Navigate to the target route
        // navigate("/dashboard", { replace: false }) // `replace: false` to preserve navigation history
    }

    // Updated useEffect to avoid resetting menu state unnecessarily
    useEffect(() => {
        const liElement = document.getElementById("mHome")
        const innerElementClass = liElement.querySelector('a')?.className

        const limSElement = document.getElementById("mWorkOrders")
        const innermSElementClass = limSElement.querySelector('a')?.className

        const limAElement = document.getElementById("mAccount")
        const innermAElementClass = limAElement.querySelector('a')?.className

        const seaElement = document.getElementById("mSeaManagement")
        const innerseaElementClass = seaElement?.querySelector('a')?.className

        // const limRElement = document.getElementById("mRoleManagement")
        // const innermRElementClass = limRElement.querySelector('a')?.className

        // const msDashboard = document.getElementById("mDashboard")
        // const msDashboardClass = msDashboard.querySelector('a').className

        if (hasActiveChild(item, currentURL)) {
            if (!groupActive.includes(item.id)) {
                groupActive.push(item.id)
            }
        } else {
            const index = groupActive.indexOf(item.id)
            if (index > -1) {
                groupActive.splice(index, 1)
            }
        }

        // Avoid resetting `groupOpen` entirely, only update based on currentActiveGroup
        if (!groupActive.includes(item.id)) {
            setGroupActive([...groupActive])
            setCurrentActiveGroup([...groupActive])
        }

        if (innerElementClass === "d-flex align-items-center active" || innermSElementClass === "d-flex align-items-center active" || innermAElementClass === "d-flex align-items-center active" || innerseaElementClass === "d-flex align-items-center active") {
            setGroupOpen([])
        }

    }, [location])


    // ** Returns condition to add open class
    const openClassCondition = (id) => {
        if ((menuCollapsed) || menuCollapsed === false) {
            if (groupActive.includes(id) || groupOpen.includes(id)) {
                return true
            }
        } else if (
            groupActive.includes(id) &&
            menuCollapsed
        ) {
            return false
        } else {
            return null
        }
    }

    return (
        <Fragment>
            <li
                className={classnames("nav-item has-sub ", {
                    open: openClassCondition(item.id),
                    "menu-collapsed-open": groupActive.includes(item.id),
                    "sidebar-group-active":
                        openClassCondition(item.id)
                })}
                style={{ transition: "none !important", display: item.show ? 'block' : 'none' }}
            >
                <Link
                    className={classnames("d-flex align-items-center child-sidmenu-list ", {
                        "child-sidmenu-list-active": ((menuCollapsed) || menuCollapsed === false) && (groupActive.includes(item.id) || groupOpen.includes(item.id))
                    })}
                    // to={"/dashboard"}
                    onClick={(e) => onCollapseClick(e, item)}
                >
                    {/* {item.icon} */}
                    {item.img && <img src={((menuCollapsed) || menuCollapsed === false) && (groupActive.includes(item.id) || groupOpen.includes(item.id)) ? item.img1 : item.img} style={{ width: "25px", marginRight: "13px" }}></img>}
                    <span className={classnames("menu-title text-truncate ", {
                        "child-sidmenu-list-active-text": ((menuCollapsed) || menuCollapsed === false) && (groupActive.includes(item.id) || groupOpen.includes(item.id))
                    })} style={{ fontSize: "12px" }}>{item.title}</span>

                    {item.badge && item.badgeText ? (
                        <Badge className="ms-auto me-1" color={item.badge} pill>
                            {item.badgeText}
                        </Badge>
                    ) : null}
                </Link>

                {/* Render Child Recursively Through VerticalNavMenuItems Component */}
                <ul className="menu-content">
                    <Collapse
                        isOpen={
                            (groupActive && groupActive.includes(item.id)) ||
                            (groupOpen && groupOpen.includes(item.id))
                        }
                    >
                        <VerticalNavMenuItems
                            {...rest}
                            items={item.children}
                            groupActive={groupActive}
                            setGroupActive={setGroupActive}
                            currentActiveGroup={currentActiveGroup}
                            setCurrentActiveGroup={setCurrentActiveGroup}
                            groupOpen={groupOpen}
                            setGroupOpen={setGroupOpen}
                            parentItem={item}
                            menuCollapsed={menuCollapsed}
                            menuHover={menuHover}
                            activeItem={activeItem}
                        />
                    </Collapse>
                </ul>
            </li>

        </Fragment>

    )
}

export default VerticalNavMenuGroup
